/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import get from 'lodash/get';

import Carousel, { Slide } from '@redbubble/design-system/react/Carousel';
import * as constants from '@redbubble/design-system/react/constants';

import ProductCard from '../ProductCard';
import styles from './ProductRecommendations.css';
import LoadingSlides from '../LoadingSlides';

class ProductRecommendations extends Component {
  constructor(props) {
    super(props);
    this.carousel = this.carousel.bind(this);
  }

  get slidesPerView() {
    const { browser } = this.props;

    return browser.is.large ? 3 : browser.is.medium ? 2 : 1;
  }

  carousel() {
    const { loading, browser, showStrikethroughPricing } = this.props;

    const carouselConfig = {
      showControls: false,
      slidesPerView: this.slidesPerView,
      profile: browser.is.large ? constants.DESKTOP : constants.MOBILE
    };

    if (loading) {
      return (
        <Carousel {...carouselConfig} key="product_loading_carousel">
          {LoadingSlides({ numberOfItems: this.slidesPerView })}
        </Carousel>
      );
    }

    return (
      <Carousel {...carouselConfig} key="product_carousel">
        {this.props.products.map(product => {
          const { inventoryItem } = product || {};
          const { preview } = inventoryItem || {};

          return (
            <Slide key={`productRecommendation-${product.inventoryItemId}`}>
              <ProductCard
                item={inventoryItem}
                previewUrl={get(preview, 'url')}
                showStrikethroughPricing={showStrikethroughPricing}
              />
            </Slide>
          );
        })}
      </Carousel>
    );
  }

  render() {
    const { error, loading, products } = this.props;

    if (error || (products.length === 0 && !loading)) {
      return null;
    }

    return <div className={styles.carouselContainer}>{this.carousel()}</div>;
  }
}

ProductRecommendations.propTypes = {
  browser: PropTypes.shape({}),
  workId: PropTypes.string,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      inventoryItemId: PropTypes.string,
      inventoryItem: PropTypes.shape({})
    })
  ),
  showStrikethroughPricing: PropTypes.bool
};

ProductRecommendations.displayName = 'ProductRecommendations';

ProductRecommendations.fragment = gql`
  fragment ProductRecommendations on guru_InventoryItemRecommendation {
    inventoryItemId
    inventoryItem(locale: $locale) {
      description
      productPageUrl(locale: $locale)
      preview(previewTypeId: "product_close") {
        url
      }
      price(currency: $currency, country: $country) {
        amount
        currency
        discount {
          amount
          percent
        }
      }
      volumeDiscount {
        thresholds {
          quantity
          percentOff
        }
      }
    }
  }
`;

ProductRecommendations.defaultProps = {
  products: []
};

export default ProductRecommendations;
